<template>
  <div>
    <accordion>
        <accordion-item>
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          <template slot="accordion-trigger">
            <h5 data-qa="aboutStripeTitle">{{ $t('faqEurosender1') }}</h5>
          </template>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <template slot="accordion-content">
            <p data-qa="aboutStripeText" class="textAccordion">{{ $t('faqEurosender1a') }} <br/> {{ $t('faqEurosender1b') }}</p>
			<a href="https://www.eurosender.com/sl/" target="_blank"><img style="width: 150px; margin-left:0;" src="../../assets/static/images/logo/eurosender_logo.png"></a>
			<br/>
          </template>
        </accordion-item>

        <accordion-item>
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          <template slot="accordion-trigger">
            <h5 data-qa="setupStripeAccountTitle">{{ $t('faqEurosender2') }}</h5>
          </template>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <template slot="accordion-content">
            <br/>
            <p data-qa="setupStripeAccountText" class="textAccordion">{{ $t('faqEurosender2a') }} <strong>{{ $t('faqEurosender2a1') }}</strong>.</p>
            <a style="color: var(--primaryDark);" href="https://www.eurosender.com/sl/account/register" target="_blank">{{ $t('createBusinessAccount') }}</a>
			<br/>
            <br/>
          </template>
        </accordion-item>

        <accordion-item>
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          	<template slot="accordion-trigger">
          		<h5 data-qa="stripeApiKeysTitle">{{ $t('faqEurosender3') }}</h5>
          	</template>
          <!-- This slot will handle all the content that is passed to the accordion -->
          	<template slot="accordion-content">
            	<br/>
            	<p data-qa="stripeApiKeysText" class="textAccordion">{{ $t('liveEuroSenderKeysTooltip') }}</p>
				<img style="width: 100%;" src="../../assets/static/images/screens/eurosender_publicAPI.png">
			</template>
        </accordion-item>
      </accordion>
  </div>
</template>

<script>
import Accordion from "@/components/common/accordion";
import AccordionItem from "@/components/common/accordion-item";

export default {
  components: {
    Accordion,
    AccordionItem
  }
};
</script>

<style lang="scss" scoped>

/* Then style the iframe to fit in the container div with full height and width */
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.responsive {
  width: 100%;
  height: auto;
}
.stripeLogo {
    max-width: 250px;
  }

.textAccordion {
  text-align: justify;
  font-size: 0.75em;
}
  @media screen and (max-width: 500px) {
h5 {
    font-size: 0.8rem;
    text-align: left;
    }
.textAccordion {
  margin-bottom: 0;
}
  }
</style>
